import { useState } from "react";
import type { BobState } from "../types";
import { gradeRepo } from "../lib/engine/repoGrader";

interface Props {
  state: BobState;
  onUpdate: (partial: Partial<BobState>) => void;
  toast: (msg: string) => void;
}

export function RepoGraderPanel({ state, onUpdate, toast }: Props) {
  const [input, setInput] = useState("");
  const latest = state.graderResults[state.graderResults.length - 1];

  function runGrade() {
    if (!input.trim()) {
      toast("Paste repo notes or path listing first.");
      return;
    }
    const result = gradeRepo({ pathOrPaste: input });
    onUpdate({ graderResults: [...state.graderResults, result] });
    toast(`Grading complete — salvage ${result.salvageScore}/100`);
  }

  return (
    <section className="surface glass-panel">
      <h2>Repo Grader</h2>
      <p className="lead">Static deterministic audit — paste README, package.json, tree, or path notes.</p>
      <label className="form-grid">
        Repo path / paste field
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="/path/to/repo or paste manifest contents..."
        />
      </label>
      <div className="btn-row">
        <button type="button" className="btn" onClick={runGrade}>
          Run static audit
        </button>
      </div>
      {latest && (
        <>
          <div style={{ marginTop: "1rem", display: "flex", gap: "1rem", alignItems: "center" }}>
            <div className="score-ring">{latest.salvageScore}</div>
            <div>
              <div className="chip ok">Salvage score</div>
              <p style={{ margin: "0.35rem 0 0", fontSize: "0.9rem" }}>{latest.summary}</p>
              <p style={{ margin: "0.25rem 0 0", color: "var(--accent-cobalt)", fontSize: "0.85rem" }}>
                {latest.suggestedBuildPath}
              </p>
            </div>
          </div>
          <ul className="checklist">
            {latest.checklist.map((c) => (
              <li key={c.id}>
                <span>{c.passed ? "✓" : "○"}</span>
                <span>
                  {c.label} — <span style={{ color: "var(--text-muted)" }}>{c.detail}</span>
                </span>
              </li>
            ))}
          </ul>
          {latest.riskFlags.length > 0 && (
            <div className="output-box">
              {latest.riskFlags.map((r) => (
                <div key={r.id} className={`risk-${r.severity}`}>
                  [{r.severity}] {r.category}: {r.message}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </section>
  );
}
